const CommonImages = {
  bannerImage:
    "https://omic-staging.s3.amazonaws.com/static/img/login/banner1.ce022a8cbc5d.png",
};

export default CommonImages;
